/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineClubStepComponentProps } from './wine-club.types';

//==============================================================================
/**
 * WineClubConfirmation component
 * @extends {React.Component<IWineClubStepComponentProps>}
 */
//==============================================================================
@observer
class WineClubConfirmation extends React.Component<IWineClubStepComponentProps> {

    //==========================================================================
    // Public Methods
    //==========================================================================

    public render(): JSX.Element {
        const { resources } = this.props;
        const shippingAddress = this.props.fields.shippingAddress;

        return (
            <div className='wine-club-confirmation'>
                <div className='wine-club-content'>
                    <h2 className='wine-club-subheading'>{resources && resources.wineClub_confirmationHeading}</h2>
                    <p className='wine-club-text'>{resources && resources.wineClub_confirmationText}</p>
                    <div className='wine-club-form'>
                        <div className='wine-club-input-group'>
                            <div className='wine-club-summary wine-club-summary-shipping-address'>
                                <h6 className='wine-club-summary-heading'>{resources && resources.wineClub_confirmationShippingAddressHeading}</h6>
                                <p className='wine-club-summary-line wine-club-summary-line-name'>{shippingAddress.firstName} {shippingAddress.lastName}</p>
                                <p className='wine-club-summary-line wine-club-summary-line-address1'>{shippingAddress.address1}</p>
                                {shippingAddress.address2 ? (<p className='wine-club-summary-line wine-club-summary-line-address2'>{shippingAddress.address2}</p>) : null}
                                <p className='wine-club-summary-line wine-club-summary-line-citystatezip'>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip}</p>
                                <p className='wine-club-summary-line wine-club-summary-line-country'>{shippingAddress.country}</p>
                                <p className='wine-club-summary-line wine-club-summary-line-phone'>{shippingAddress.phone}</p>
                                <p className='wine-club-summary-line wine-club-summary-line-email'>{shippingAddress.email}</p>
                            </div>
                        </div>
                        <div className='wine-club-button-group'>
                            {resources && resources.wineClub_buttonBack &&
                                this.props.renderButton(
                                    resources.wineClub_buttonBack,
                                    'shipping',
                                    this.props.toggleStep,
                                    'wine-club-button-back'
                                )
                            }
                            {resources && resources.wineClub_buttonSignup &&
                                this.props.renderSubmit(
                                    resources.wineClub_buttonSignup,
                                    'wine-club-button-signup'
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WineClubConfirmation;